export default __webpack_public_path__ + "static/media/icon_policy_overview_step1_table.e4ad0cbc.svg";